import { Box, TabItem, Tabs as UIKitTabs } from "@modernatx-internal/component-library";
import React from "react";

import { useExperience } from "@/context/ExperienceContext";

import { ContentComponentProps, TabContent, TabsContent } from "../types";
import { PageHeaderScrollable } from "./PageHeader";

export const Tabs: React.FC<ContentComponentProps<TabsContent>> = ({
  children,
  scrollable = false,
  ...props
}) => {
  const { expandedMode } = useExperience();
  const [itemIdActive, itemIdActiveSet] = React.useState<string | null>("0");
  const items = React.Children.map(children, (child, i) => {
    if (React.isValidElement(child)) {
      const tabItem: TabItem = {
        id: String(i),
        label: child.props.tab?.label
      };

      return {
        children: child.props.children,
        tabItem
      };
    }

    return null;
  });
  const itemSelected = items?.find(({ tabItem }) => tabItem.id === itemIdActive);

  const renderTabBar = (tabs: React.ReactNode) =>
    scrollable ? (
      <PageHeaderScrollable>
        <Box sx={{ display: "inline-flex", minWidth: "100%", whiteSpace: "nowrap" }}>{tabs}</Box>
      </PageHeaderScrollable>
    ) : (
      tabs
    );

  // If we are in expanded mode, show all tab states
  if (expandedMode) {
    return items?.map((item, i) => (
      <React.Fragment key={i}>
        {renderTabBar(
          <UIKitTabs
            defaultSelectedTabId={item.tabItem.id}
            items={items?.map(({ tabItem }) => tabItem) || []}
            onClickTab={() => {}}
          />
        )}
        {item && <Box>{item.children}</Box>}
      </React.Fragment>
    ));
  }

  return (
    <>
      {renderTabBar(
        <UIKitTabs
          items={items?.map(({ tabItem }) => tabItem) || []}
          onClickTab={(itemActiveNext) => itemIdActiveSet(itemActiveNext)}
          {...props}
        />
      )}
      {itemSelected && <Box>{itemSelected.children}</Box>}
    </>
  );
};

export const Tab: React.FC<ContentComponentProps<TabContent>> = ({ children }) => children;
